import './PracticeCategoryFilter.scss'

import { useEffect, useRef, createRef } from 'react'
import Button from 'react-bootstrap/Button'
import parse from 'html-react-parser'
import cn from 'classnames'
import {
  EVENT_ACTION_FILTER,
  saveUserEvent,
  EVENT_CATEGORY_PRACTICES
} from 'components/common/api/UserEvents'

/**
 * Simple Practice Category Filter component.
 * Used to modify the Practice categories displayed on the Practice listing screen
 */
export default function PracticeCategoryFilter({
  activeFilterIndex = 0,
  setActiveFilter,
  categories,
  setNewCategoriesFiltered
}) {
  const buttonRefs = useRef([])

  buttonRefs.current = categories.map(
    (_, index) => buttonRefs.current[index] ?? createRef()
  )

  const handleClick = (category, index) => {
    // Do we have a category filter?
    if (setNewCategoriesFiltered) {
      // Use the subcategories if we have them, otherwise use the category
      const filteredCategories =
        categories[index]?.subcategories?.length > 0
          ? categories[index].subcategories
          : categories[index]
      setNewCategoriesFiltered(filteredCategories)
    }

    setActiveFilter(index)

    // Log filter action
    saveUserEvent(EVENT_CATEGORY_PRACTICES, EVENT_ACTION_FILTER, category.name)
  }

  useEffect(() => {}, [activeFilterIndex])

  return (
    categories?.length > 0 && (
      <div className='scrolling-card-wrapper relationship-category-filter'>
        <div className='scrolling-card-cards'>
          {categories.map(
            (category, index) =>
              category.name && (
                <Button
                  ref={buttonRefs.current[index]}
                  variant='secondary'
                  key={index}
                  className={cn(
                    'relationship-category-item d-inline-flex justify-content-between align-items-center px-3',
                    {
                      active: activeFilterIndex === index
                    }
                  )}
                  onClick={_ => handleClick(category, index)}
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  <span>{parse(category.name)}</span>

                  <span
                    className={cn('total-categories', {
                      show:
                        activeFilterIndex !== 0 && activeFilterIndex === index
                    })}
                  ></span>
                </Button>
              )
          )}
        </div>
      </div>
    )
  )
}
